"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interactablePressedOpacity = exports.interactablePressedBackground = exports.interactableHoveredOpacity = exports.interactableHoveredBackground = exports.interactableDisabledBackground = exports.interactableBorderRadius = exports.interactableBackground = void 0;
const interactableBorderRadius = '--interactable-border-radius';
exports.interactableBorderRadius = interactableBorderRadius;
const interactableBackground = '--interactable-background';
// Pressed:
exports.interactableBackground = interactableBackground;
const interactablePressedBackground = '--interactable-pressed-background';
exports.interactablePressedBackground = interactablePressedBackground;
const interactablePressedOpacity = '--interactable-pressed-opacity';
// Hovered:
exports.interactablePressedOpacity = interactablePressedOpacity;
const interactableHoveredBackground = '--interactable-hovered-background';
exports.interactableHoveredBackground = interactableHoveredBackground;
const interactableHoveredOpacity = '--interactable-hovered-opacity';
// Disabled:
exports.interactableHoveredOpacity = interactableHoveredOpacity;
const interactableDisabledBackground = '--interactable-disabled-background';
exports.interactableDisabledBackground = interactableDisabledBackground;